const cached = {};
const utils = {
  getTag(target) {
    return Object.prototype.toString.call(target);
  },
  baseMerge(target, filterFn, ...sources) {
    if (!target) target = {};

    sources
      .filter((v) => v && typeof v === 'object')
      .forEach((source) => {
        Object.keys(source).forEach((key) => {
          const targetTag = utils.getTag(target[key]);
          const sourceTag = utils.getTag(source[key]);

          if (sourceTag === '[object Array]' || sourceTag === '[object Object]') {
            if (targetTag !== sourceTag) target[key] = sourceTag === '[object Array]' ? [] : {};
            utils.baseMerge(target[key], filterFn, source[key]);
          } else if (filterFn(target, source, key)) {
            target[key] = source[key];
          }
        });
      });

    return target;
  },
  merge(target, ...sources) {
    return utils.baseMerge(target, filterFn, ...sources);
  },
  dispatch: function (context, componentName, eventName, params) {
    let parent = context.$parent || context.$root;
    let name = parent.$options.name;

    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent;

      if (parent) {
        name = parent.$options.name;
      }
    }
    if (parent) {
      parent.$bus?.$emit([eventName], params);
    }
  },
  broadcast: function (context, componentName, eventName, params) {
    broadcast.call(context, componentName, eventName, params);
  },
  findParentComponent(_context, componentName) {
    const parent = _context.parent;
    if (parent) {
      if (parent.type.name && parent.type.name === componentName) {
        return parent;
      } else {
        return this.findParentComponent(parent, componentName);
      }
    }
  },
  findComponentUpward: function (_context, componentName, componentNames) {
    const parent = this.findParentComponent(_context, componentName);
    if (parent) {
      const { proxy } = parent;
      return proxy;
    }
  },
  findComponentsUpward: function (_context, componentName, componentNames) {
    const components = [];

    if (typeof componentName === 'string') {
      componentNames = [componentName];
    } else {
      componentNames = componentName;
    }

    let parent = this.findParentComponent(_context, componentName);
    const name = parent.type.name;
    while (parent) {
      if (componentNames.indexOf(name) > -1) {
        components.push(parent.proxy);
      }
      parent = parent.parent;
    }
    return components;
  },
  findComponentsDownward: function (context, componentName, comps) {
    const components = comps || [];
    // const childrens = context.$children;
    //
    // if (childrens.length) {
    //   childrens.forEach(function (child) {
    //     const name = child.$options.name;
    //     const childs = child.$children;
    //
    //     if (name === componentName) components.push(child);
    //     if (childs.length) {
    //       const findChilds = utils.findComponentsDownward(child, componentName, components);
    //       if (findChilds) components.concat(findChilds);
    //     }
    //   });
    // }

    // context.subTree.dynamicChildren.forEach((e) => {
    //   if (e.type) {
    //     console.log(e);
    //   }
    // });

    return components;
  },
  oneOf: function (value, validList) {
    for (let i = 0; i < validList.length; i++) {
      if (value === validList[i]) {
        return true;
      }
    }
    return false;
  },
  camelCase: function (str) {
    const SPECIAL_CHARS_REGEXP = /-(\w)/g;

    return str.replace(SPECIAL_CHARS_REGEXP, function ($0, $1) {
      return $1.toUpperCase();
    });
  },
  getStyle: function (element, styleName) {
    if (!element || !styleName) return null;
    styleName = utils.camelCase(styleName);
    if (styleName === 'float') {
      styleName = 'cssFloat';
    }
    try {
      const computed = document.defaultView.getComputedStyle(element, '');
      return element.style[styleName] || computed ? computed[styleName] : null;
    } catch (e) {
      return element.style[styleName];
    }
  },
  setStyle: function (elementList, styleName, style) {
    if (!elementList.length || !styleName) return null;
    styleName = utils.camelCase(styleName);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    for (let i = 0; i < elementList.length; i++) {
      elementList[i].style[styleName] = style;
    }
  },
  isValueNumber: function (value) {
    return /^[1-9][0-9]*$/.test(value + '');
  },
  // 求值并记忆默认的滚动条的宽度
  scrollbarWidth: function (baseDom) {
    const _baseDom = baseDom || document.body;
    const outer = document.createElement('div');
    outer.className = 'jz-scrollbar-wrap';
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    _baseDom.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    const scrollBarWidth = widthNoScroll - widthWithScroll;

    return scrollBarWidth;
  },
  off: function (element, event, handler) {
    if (element && event) {
      element.removeEventListener(event, handler, false);
    }
  },
  on: function (element, event, handler) {
    if (element && event && handler) {
      element.addEventListener(event, handler, false);
    }
  },
  throttle: function (fn, wait) {
    let startTime = 0;
    wait = wait || 200;
    return function () {
      const endTime = +new Date();
      if (endTime - startTime > wait) {
        fn.apply(this, arguments);
        startTime = endTime;
      }
    };
  },
  debounce: function (fn, delay) {
    let timer = null;
    delay = delay || 40;
    return function () {
      // const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(this, args);
      }, delay);
    };
  },
  initDefaultProps: function (props, defaultData) {
    let key, type, prop;
    for (key in defaultData) {
      if (typeof props[key] === 'object') {
        // props[key] = props[key];
      } else if (typeof props[key] === 'function') {
        props[key] = { type: props[key] };
      } else if (!props[key]) {
        props[key] = {};
      }
      props[key].default = defaultData[key];
    }
    return props;
  },
  typeOf: function (obj) {
    const toString = Object.prototype.toString;
    const map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object',
    };
    return map[toString.call(obj)];
  },
  deepCopy: function (data) {
    // return data;
    const t = utils.typeOf(data);
    let o;

    if (t === 'array') {
      o = [];
    } else if (t === 'object') {
      o = {};
    } else {
      return data;
    }

    if (t === 'array') {
      for (var i = 0; i < data.length; i++) {
        o.push(utils.deepCopy(data[i]));
      }
    } else if (t === 'object') {
      for (var i in data) {
        o[i] = utils.deepCopy(data[i]);
      }
    }
    return o;
  },
  stringToIntArray: function (arr) {
    return arr.map(function (item) {
      return +item;
    });
  },
  trim: function (string) {
    return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
  },
  addClass: function (el, cls) {
    if (!el) return;

    const curClass = el.className;
    const classes = (cls || '').split(' ');

    for (let i = 0, j = classes.length; i < j; i++) {
      const clsName = classes[i];
      if (!clsName) continue;

      if (el.classList) {
        el.classList.add(clsName);
      } else {
        // if (!hasClass(el, clsName)) {
        //   curClass += ' ' + clsName;
        // }
      }
    }
    if (!el.classList) {
      el.className = curClass;
    }
  },
  removeClass: function (el, cls) {
    if (!el || !cls) return;

    const classes = cls.split(' ');
    const curClass = ' ' + el.className + ' ';

    for (let i = 0, j = classes.length; i < j; i++) {
      const clsName = classes[i];
      if (!clsName) continue;

      if (el.classList) {
        el.classList.remove(clsName);
      } else {
        // if (hasClass(el, clsName)) {
        //   curClass = curClass.replace(' ' + clsName + ' ', ' ');
        // }
      }
    }

    if (!el.classList) {
      el.className = utils.trim(curClass);
    }
  },
  isNull: function (obj) {
    return typeof obj === 'undefined' || obj == null;
  },
  Img: {
    MODE_SCALE_FILL: 1, // 根据区域能够填满的最大值等比例缩放。图片100x50，区域50x50，结果50x25。
    MODE_SCALE_WIDTH: 2, // 根据区域宽度等比例缩放，结果高度将不受区域高度限制，即可能撑大高度。图片100x50，区域50x10，结果50x25。
    MODE_SCALE_HEIGHT: 3, // 根据区域高度等比例缩放，结果宽度将不受区域宽度限制，即可能撑大宽度。图片100x50，区域50x50，结果100x50。
    MODE_SCALE_DEFLATE_WIDTH: 4, // 根据区域宽度等比例缩小，不放大，结果高度将不受区域高度限制。图片100x50，区域50x10，结果50x25；图片100x50，区域200x100，结果100x50。
    MODE_SCALE_DEFLATE_HEIGHT: 5, // 根据区域高度等比例缩小，不放大，结果宽度将不受区域高度限制。图片100x50，区域50x50，结果100x50；图片100x50，区域200x100，结果100x50。
    MODE_SCALE_DEFLATE_FILL: 6, // 根据区域能够填满的最大值等比例缩小，不放大。图片100x50，区域50x50，结果50x25。
    MODE_SCALE_DEFLATE_MAX: 7, // 根据区域等比例缩小，不放大，结果的宽度和高度不能同时超过区域限制。图片200x100，区域100x100，结果200x100；图片100x200，区域100x100，结果100x200。
  },
  calcSize: function (width, height, maxWidth, maxHeight, mode) {
    const size = { width, height };
    if (mode === utils.Img.MODE_SCALE_FILL) {
      var rateWidth = width / maxWidth;
      var rateHeight = height / maxHeight;

      if (rateWidth > rateHeight) {
        size.width = maxWidth;
        size.height = height / rateWidth;
      } else {
        size.width = width / rateHeight;
        size.height = maxHeight;
      }
    } else if (mode === utils.Img.MODE_SCALE_WIDTH) {
      var rateWidth = width / maxWidth;
      size.width = maxWidth;
      size.height = height / rateWidth;
    } else if (mode === utils.Img.MODE_SCALE_HEIGHT) {
      var rateHeight = height / maxHeight;
      size.width = width / rateHeight;
      size.height = maxHeight;
    } else if (mode === utils.Img.MODE_SCALE_DEFLATE_WIDTH) {
      var rateWidth = width / maxWidth;
      if (rateWidth > 1) {
        size.width = maxWidth;
        size.height = height / rateWidth;
      }
    } else if (mode === utils.Img.MODE_SCALE_DEFLATE_HEIGHT) {
      var rateHeight = height / maxHeight;
      if (rateHeight > 1) {
        size.width = width / rateHeight;
        size.height = maxHeight;
      }
    } else if (mode === utils.Img.MODE_SCALE_DEFLATE_FILL) {
      var rateWidth = width / maxWidth;
      var rateHeight = height / maxHeight;

      if (rateWidth > rateHeight) {
        if (rateWidth > 1) {
          size.width = maxWidth;
          size.height = height / rateWidth;
        }
      } else {
        if (rateHeight > 1) {
          size.width = width / rateHeight;
          size.height = maxHeight;
        }
      }
    } else if (mode === utils.Img.MODE_SCALE_DEFLATE_MAX) {
      if (width > maxWidth && height > maxHeight) {
        var rateWidth = width / maxWidth;
        var rateHeight = height / maxHeight;

        if (rateWidth < rateHeight) {
          size.width = maxWidth;
          size.height = height / rateWidth;
        } else {
          size.width = width / rateHeight;
          size.height = maxHeight;
        }
      }
    }
    size.width = Math.floor(size.width);
    size.height = Math.floor(size.height);
    if (size.width === 0) {
      size.width = 1;
    }
    if (size.height === 0) {
      size.height = 1;
    }
    return size;
  },
  /* 使用此函数时，不要在img标签中先设置大小，会使得调整img大小时失败；先隐藏图片，避免出现图片从原始图片变为目标图片的过程
   *	copy建站Fai下的方法
   * 	<img src="xx.jpg" style="display:none;" onload="Fai.Img.optimize(this, {width:100, height:50, mode:Fai.Img.MODE_SCALE_FILL});"/>
   */
  optimize: function (img, option) {
    // ie下对于display:none的img不会加载
    // 这里要用临时图片，是因为当动态改变图片src时，由于图片的大小已经被设置，因此再次获取会失败
    const imgTmp = new Image();
    // 这里还不能先置空，否则将会引起对''文件的一次访问
    //	imgTmp.src = '';
    imgTmp.src = img.src;
    let imgWidth = imgTmp.width;
    let imgHeight = imgTmp.height;
    if (utils.isNull(imgWidth) || imgWidth === 0 || utils.isNull(imgHeight) || imgHeight === 0) {
      // chrome似乎对临时图片的加载会有延迟，立即取大小会失败
      imgWidth = img.width;
      imgHeight = img.height;
    }

    const size = utils.calcSize(imgWidth, imgHeight, option.width, option.height, option.mode);
    img.width = size.width;
    img.height = size.height;
    if (option.display === 1) {
      img.style.display = 'inline';
    } else if (option.display === 2) {
      img.style.display = 'none';
    } else if (option.display === 3) {
      img.style.display = 'inline-block';
    } else {
      img.style.display = 'block';
    }
    return { width: img.width, height: img.height };
  },
  slideUp: function (element, animationTime, callback) {
    let upMorphTimer;

    const options = {
      height: 0,
      padding: {
        top: 0,
        bot: 0,
      },
      margin: {
        top: 0,
        bot: 0,
      },
    };

    morph(upMorphTimer, element, options, animationTime, function (Properties) {
      const AttrElementStyle = element.style;

      AttrElementStyle.width = '';
      AttrElementStyle.height = '';
      AttrElementStyle.padding = '';
      AttrElementStyle.margin = '';
      element.style.display = 'none';

      if (callback) callback();
    });
  },
  slideDown: function (element, animationTime, callback) {
    if (!element) return;

    let downMorphTimer;
    const AttrElementStyle = element.style;
    const ComputedElementStyle = window.getComputedStyle(element, null);

    AttrElementStyle.display = 'block';

    const options = {
      width: parseInt(ComputedElementStyle.getPropertyValue('width')),
      height: parseInt(ComputedElementStyle.getPropertyValue('height')),
      padding: {
        top: parseInt(ComputedElementStyle.getPropertyValue('padding-top')),
        bot: parseInt(ComputedElementStyle.getPropertyValue('padding-bottom')),
      },
      margin: {
        top: parseInt(ComputedElementStyle.getPropertyValue('margin-top')),
        bot: parseInt(ComputedElementStyle.getPropertyValue('margin-bottom')),
      },
    };

    AttrElementStyle.height = '0';
    AttrElementStyle.paddingTop = '0';
    AttrElementStyle.paddingBottom = '0';
    AttrElementStyle.marginTop = '0';
    AttrElementStyle.marginBottom = '0';

    morph(downMorphTimer, element, options, animationTime, function () {
      AttrElementStyle.width = '';
      AttrElementStyle.height = '';
      AttrElementStyle.padding = '';
      AttrElementStyle.margin = '';

      element.style.display = 'block';

      if (callback) callback();
    });
  },
  isUndef: function (v) {
    return v === undefined || v === null;
  },
  isDef: function (v) {
    return v !== undefined && v !== null;
  },
  once: function (func) {
    let ran, result;

    return function () {
      if (ran) {
        return result;
      }
      ran = true;
      result = func.apply(this, arguments);

      func = null;
      return result;
    };
  },
  Background: {
    IMAGE_POSITION: [
      {
        key: 'left-top',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'left',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        key: 'center-top',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        key: 'right-top',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'right',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        key: 'left-center',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'left',
        backgroundPositionY: 'center',
        backgroundSize: 'auto',
      },
      {
        key: 'center-center',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'auto',
      },
      {
        key: 'right-center',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'right',
        backgroundPositionY: 'center',
        backgroundSize: 'auto',
      },
      {
        key: 'left-bottom',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'left',
        backgroundPositionY: 'bottom',
        backgroundSize: 'auto',
      },
      {
        key: 'center-bottom',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'bottom',
        backgroundSize: 'auto',
      },
      {
        key: 'right-bottom',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'right',
        backgroundPositionY: 'bottom',
        backgroundSize: 'auto',
      },
    ],
    PAVING_EFFECT: [
      {
        label: '默认',
        key: 'default',
        backgroundRepeat: 'repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'auto',
      },
      {
        label: '缩放平铺',
        key: 'zoom-tile',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
        backgroundSize: '100%',
      },
      {
        label: '上',
        key: 'top',
        backgroundRepeat: 'repeat-x',
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        label: '中-横向',
        key: 'in-horizontal',
        backgroundRepeat: 'repeat-x',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'auto',
      },
      {
        label: '下',
        key: 'bottom',
        backgroundRepeat: 'repeat-x',
        backgroundPositionX: 'center',
        backgroundPositionY: 'bottom',
        backgroundSize: 'auto',
      },
      {
        label: '左',
        key: 'left',
        backgroundRepeat: 'repeat-y',
        backgroundPositionX: 'left',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        label: '中-纵向',
        key: 'in-vertical',
        backgroundRepeat: 'repeat-y',
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
      {
        label: '右',
        key: 'right',
        backgroundRepeat: 'repeat-y',
        backgroundPositionX: 'right',
        backgroundPositionY: 'top',
        backgroundSize: 'auto',
      },
    ],
    SCALING_STRETCH: [
      {
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'left',
        backgroundPositionY: 'center',
        backgroundSize: '100% 100%',
      },
    ],
    SCALING_FILL: [
      {
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'cover',
      },
    ],
    SCALING_CONTAIN: [
      {
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'contain',
      },
    ],
  },
  parseBackgroundImageUrl: function (backgroundImage) {
    let ret = '';
    if (backgroundImage) {
      const found = backgroundImage.match(/url\(\s*['|""]?\s*(\S+)\s*['|""]?\s*\)/);
      if (found && found[1]) {
        ret = found[1];
      }
    }
    return ret;
  },
  parseBackgroundImageGradient: function (backgroundImage) {
    let ret = '';
    if (backgroundImage) {
      const found = backgroundImage.match(/linear-gradient\(\s*.+\s*\)/);
      if (found && found[0]) {
        ret = found[0];
      }
    }
    return ret;
  },
  concatBackgroundColor: function (color) {
    return /linear-gradient\(/.test(color) ? '' : color;
  },
  concatBackgroundImage: function (imageUrl, color) {
    return [imageUrl ? 'url(' + imageUrl + ')' : '', /linear-gradient\(/.test(color) ? color : '']
      .filter(function (x) {
        return x;
      })
      .join(',');
  },
  contentLoaded: function (win, fn) {
    let done = false;
    let top = true;
    const doc = win.document;
    const root = doc.documentElement;
    const modern = doc.addEventListener;
    const add = modern ? 'addEventListener' : 'attachEvent';
    const rem = modern ? 'removeEventListener' : 'detachEvent';
    const pre = modern ? '' : 'on';
    var init = function (e) {
      if (e.type === 'readystatechange' && doc.readyState !== 'complete') return;
      (e.type === 'load' ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) fn.call(win, e.type || e);
    };
    var poll = function () {
      try {
        root.doScroll('left');
      } catch (e) {
        setTimeout(poll, 50);
        return;
      }
      init('poll');
    };

    if (doc.readyState === 'complete') fn.call(win, 'lazy');
    else {
      if (!modern && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (e) {}
        if (top) poll();
      }
      doc[add](pre + 'DOMContentLoaded', init, false);
      doc[add](pre + 'readystatechange', init, false);
      win[add](pre + 'load', init, false);
    }
  },
};

function broadcast(componentName, eventName, params) {
  this.$children?.forEach(function (child) {
    const name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      // todo 如果 params 是空数组，接收到的会是 undefined
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

function morph(morphTimer, element, options, animationTime, callback) {
  const ComputedElementStyle = window.getComputedStyle(element, null);
  const AttrElementStyle = element.style;
  const Properties = {
    width: parseInt(ComputedElementStyle.getPropertyValue('width')),
    height: parseInt(ComputedElementStyle.getPropertyValue('height')),
    padding: {
      top: parseInt(ComputedElementStyle.getPropertyValue('padding-top')),
      right: parseInt(ComputedElementStyle.getPropertyValue('padding-right')),
      bot: parseInt(ComputedElementStyle.getPropertyValue('padding-bottom')),
      left: parseInt(ComputedElementStyle.getPropertyValue('padding-left')),
    },
    margin: {
      top: parseInt(ComputedElementStyle.getPropertyValue('margin-top')),
      right: parseInt(ComputedElementStyle.getPropertyValue('margin-right')),
      bot: parseInt(ComputedElementStyle.getPropertyValue('margin-bottom')),
      left: parseInt(ComputedElementStyle.getPropertyValue('margin-left')),
    },
  };
  const DiffValues = {
    width: options.width != null ? options.width - Properties.width : 0,
    height: options.height != null ? options.height - Properties.height : 0,
    padding: {
      top:
        options.padding && options.padding.top != null
          ? options.padding.top - Properties.padding.top
          : 0,
      right:
        options.padding && options.padding.right != null
          ? options.padding.right - Properties.padding.right
          : 0,
      bot:
        options.padding && options.padding.bot != null
          ? options.padding.bot - Properties.padding.bot
          : 0,
      left:
        options.padding && options.padding.left != null
          ? options.padding.left - Properties.padding.left
          : 0,
    },
    margin: {
      top:
        options.margin && options.margin.top != null
          ? options.margin.top - Properties.margin.top
          : 0,
      right:
        options.margin && options.margin.right != null
          ? options.margin.right - Properties.margin.right
          : 0,
      bot:
        options.margin && options.margin.bot != null
          ? options.margin.bot - Properties.margin.bot
          : 0,
      left:
        options.margin && options.margin.left != null
          ? options.margin.left - Properties.margin.left
          : 0,
    },
  };
  const beginTime = new Date().getTime();
  let sinceBeginTime;
  let progressFactor;

  animationTime = animationTime != null ? animationTime : 250;
  AttrElementStyle.overflow = 'hidden';

  clearInterval(morphTimer);

  morphTimer = setInterval(function () {
    sinceBeginTime = new Date().getTime() - beginTime;

    if (sinceBeginTime < animationTime) {
      progressFactor = sinceBeginTime / animationTime;
      AttrElementStyle.width = Properties.width + DiffValues.width * progressFactor + 'px';
      AttrElementStyle.height = Properties.height + DiffValues.height * progressFactor + 'px';

      AttrElementStyle.padding =
        Properties.padding.top +
        DiffValues.padding.top * progressFactor +
        'px ' +
        (Properties.padding.right + DiffValues.padding.right * progressFactor) +
        'px ' +
        (Properties.padding.bot + DiffValues.padding.bot * progressFactor) +
        'px ' +
        (Properties.padding.left + DiffValues.padding.left * progressFactor) +
        'px';

      AttrElementStyle.margin =
        Properties.margin.top +
        DiffValues.margin.top * progressFactor +
        'px ' +
        (Properties.margin.right + DiffValues.margin.right * progressFactor) +
        'px ' +
        (Properties.margin.bot + DiffValues.margin.bot * progressFactor) +
        'px ' +
        (Properties.margin.left + DiffValues.margin.left * progressFactor) +
        'px';
    } else {
      AttrElementStyle.width = options.width + 'px';
      AttrElementStyle.height = options.height + 'px';

      AttrElementStyle.padding =
        Properties.padding.top +
        DiffValues.padding.top +
        'px ' +
        (Properties.padding.right + DiffValues.padding.right) +
        'px ' +
        (Properties.padding.bot + DiffValues.padding.bot) +
        'px ' +
        (Properties.padding.left + DiffValues.padding.left) +
        'px';

      AttrElementStyle.margin =
        Properties.margin.top +
        DiffValues.margin.top +
        'px ' +
        (Properties.margin.right + DiffValues.margin.right) +
        'px ' +
        (Properties.margin.bot + DiffValues.margin.bot) +
        'px ' +
        (Properties.margin.left + DiffValues.margin.left) +
        'px';

      clearInterval(morphTimer);

      if (callback != null) callback(Properties);
    }
  }, 15);
}

const filterFn = () => true;
// eslint-disable-next-line prefer-const

window.vue_utils = utils;

export default utils;
